<template>
  <div>
    <a-input placeholder="请选择店铺" v-model="chosenShowName" disabled v-if="isShowInput">
      <template #suffix>
        <a-button type="primary" @click="startChoose" :disabled="isDisabled">选择</a-button>
      </template>
    </a-input>
    <a-modal v-if="choosing || isShowModel" :visible="true" title="请选择店铺" :footer="null"
             @cancel="onCancel" width="1200">
      <div class="table-header">
        <div class="header-item">
          <a-form layout="inline">
            <a-form-item label="商户编号">
              <MchChooseDialog v-model="mchNameForQuery"
                               @chooseDone="onMchChosenForQuery"
                               :searchable="true"></MchChooseDialog>
            </a-form-item>
            <a-form-item label="店铺编号">
              <a-input v-model="queryShopNo"></a-input>
            </a-form-item>
            <a-form-item label="店铺名称">
              <a-input v-model="queryShopName"></a-input>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="onSearch">查询</a-button>
            </a-form-item>
            <a-form-item>
              <a-button @click="onReset">重置</a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
      <div class="table-main">
        <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="id" size="small">
          <span slot="action" slot-scope="text, record">
            <a-button @click="onChoose(record)" type="primary">选择</a-button>
          </span>
        </a-table>
      </div>
      <div class="paginationBox">
        <a-pagination v-model="pageNo" :total="total" :page-size="pageSize"
                      @change="onPagesizeChange"></a-pagination>
      </div>
    </a-modal>
  </div>
</template>

<script>
import MchChooseDialog from '@/view/components/ChooseDialog/MchChooseDialog.vue'

export default {
  name: 'ShopChooseDialog',
  components: {MchChooseDialog},
  model: {
    prop: 'chosenShowName',
    event: 'change',
  },
  props: {
    chosenShowName: { type: String, default: '' },
    // 按商户号过滤（可选），由父组件传入已选择的商户号
    mchNo: { type: String, default: '' },
    searchable: { type: Boolean, default: true },
    isShowInput: { type: Boolean, default: true },
    isShowModel: { type: Boolean, default: false },
    isDisabled: Boolean,
  },
  data() {
    const columns = [
      {
        title: '商户编号',
        dataIndex: 'mchNo',
        align: 'center',
        width: 150,
      },
      {
        title: '商户名称',
        dataIndex: 'mchName',
        align: 'center',
        width: 150,
        ellipsis: true,
      },
      {
        title: '店铺编号',
        dataIndex: 'shopNo',
        align: 'center',
        width: 130,
      },
      {
        title: '店铺名称',
        dataIndex: 'shopName',
        align: 'center',
        width: 150,
        ellipsis: true,
      },
      {
        title: '审批状态',
        dataIndex: 'approvalStatus',
        align: 'center',
        width: 100,
        customRender: (text) => {
          if (text === 0) return <a-tag color="#188efb">审批中</a-tag>
          if (text === 1) return <a-tag color="green">通过</a-tag>
          if (text === 2) return <a-tag color="red">拒绝</a-tag>
          return ''
        },
      },
      {
        title: '操作',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        align: 'center',
        width: 80,
      },
    ]
    return {
      choosing: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      columns,
      data: [],
      queryMchNo: '',
      queryShopNo: '',
      queryShopName: '',
      mchNameForQuery: '',
    }
  },
  created() {
    if (this.isShowModel) {
      this.loadTableData()
    }
  },
  methods: {
    startChoose() {
      this.choosing = true
      this.queryMchNo = this.mchNo || ''
      this.loadTableData()
    },
    onSearch() {
      this.pageNo = 1
      this.loadTableData()
    },
    async loadTableData() {
      const queryParam = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mchNo: this.queryMchNo,
        shopNo: this.queryShopNo,
        shopName: this.queryShopName,
      }
      const res = await this.api.managerpageApi(queryParam)
      if (res.code !== 200) {
        this.$message.error(res.info || '查询店铺失败')
      } else {
        this.data = res.data.records || []
        this.total = res.data.total || 0
        this.pageNo = res.data.current || 1
        this.pageSize = res.data.size || 10
      }
    },
    onMchChosenForQuery(record) {
      this.queryMchNo = record.mchNo
      this.onSearch()
    },
    onChoose(record) {
      this.choosing = false
      this.$emit('change', record.shopName)
      this.$emit('chooseDone', record)
    },
    onPagesizeChange(page) {
      this.pageNo = page
      this.loadTableData()
    },
    onReset() {
      this.queryMchNo = this.mchNo || ''
      this.queryShopNo = ''
      this.queryShopName = ''
      this.mchNameForQuery = ''
      this.pageNo = 1
      this.loadTableData()
    },
    onCancel() {
      this.choosing = false
      this.$emit('chooseCancel')
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1200px;

  .ant-modal-content {
    width: 100%;
  }
}

/deep/ .table-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;

  .ant-select-selection--single {
    width: 200px;
  }
}

.paginationBox {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}

.ant-btn {
  min-width: 70px;
  margin: 0;
  right: -12px;
}
</style>
